export const IndicatorRecordingInProgress = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_287_17700)">
        <circle
          id="a"
          opacity="0.3"
          cx="9.99988"
          cy="10"
          r="10"
          fill="#D11D35"
        />
        <circle
          cx="9.99988"
          cy="10"
          r="6"
          fill="#D11D35"
        />
      </g>
      <defs>
        <clipPath id="clip0_287_17700">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(-0.00012207)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
